import { useState, useEffect } from "react";
import BedroomPopup from "./Bedroom Popup";
import PrepaymentPolicyModal from "./PrepaymentPolicyModal";
import "./style.css"
import { useNavigate } from "react-router-dom";
import { TAX_PERCENT, calcTaxAmount } from "../../../utils/tax";
import { setStoredGuests } from "../../../utils/guestSelection";
import { getGuestPrepaymentPercent } from "../../../utils/prepayment";

const formatBedDisplayName = (name) => {
  const raw = String(name || "").trim();
  if (!raw || /^full( bed)?$/i.test(raw)) return "King Bed";
  return raw;
};

const Layout = ({
  villaData,
  adults,
  setAdults,
  children,
  setChildren,
  infants = 0,
  setInfants,
  pets = 0,
  setPets,
  endDate,
  startDate,
}) => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPolicyOpen, setIsPolicyOpen] = useState(false);
  const [totalPrice, setTotalPrice] = useState(villaData.price_guest_pay);
  const [availability, setAvailability] = useState(true);
  const [extraPrice, setExtraPrice] = useState(0);
  const [pax, setPax] = useState(adults + children + infants);
  const [DateNull, SetDateNull] = useState(false)
  const maxPax = villaData.number_of_adults + Math.ceil(villaData.number_of_children / 2);
  const includedPax =
    villaData.standard_occupany ? villaData.standard_occupany : maxPax;
  const capacityPax = adults + children;
  const allowsPets = (villaData.amenities || []).some((amenity) =>
    String(amenity?.name || "").toLowerCase().includes("pet")
  );

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  const data = [
    { bedroom: "Bedroom 1", beds: "1 double bed" },
    { bedroom: "Bedroom 2", beds: "2 double bed" },
    { bedroom: "Bedroom 3", beds: "1 double bed" },
    { bedroom: "Bedroom 4", beds: "1 double bed" },
    { bedroom: "Bedroom 5", beds: "1 double bed" },
    { bedroom: "Bedroom 6", beds: "1 twin bed" },
  ];

  // Some villas accumulated duplicate rooms from repeated saves without room ids.
  // Keep one entry per room_type + room_name (prefer entries that still have beds).
  const rawRooms = Array.isArray(villaData?.villarooms)
    ? villaData.villarooms
    : [];
  const dedupedRooms = [];
  const seenRoomKeys = new Map();
  rawRooms.forEach((room) => {
    const beds = (room.villaroom_bed || [])
      .filter((bed) => Number(bed.quantity) > 0)
      .map((bed) => ({
        quantity: bed.quantity,
        name: formatBedDisplayName(bed.name),
        size: bed.size,
      }));
    const key = `${room.room_type || ""}|${String(
      room.room_name || room.room_number || room.id || ""
    )
      .trim()
      .toLowerCase()}`;
    const normalized = {
      id: room.id,
      room_type: room.room_type,
      room_name: room.room_name,
      room_number: room.room_number,
      bed: beds,
    };
    if (!seenRoomKeys.has(key)) {
      seenRoomKeys.set(key, dedupedRooms.length);
      dedupedRooms.push(normalized);
      return;
    }
    const idx = seenRoomKeys.get(key);
    // Prefer the copy that actually has beds configured
    if (
      beds.length > 0 &&
      (!dedupedRooms[idx].bed || dedupedRooms[idx].bed.length === 0)
    ) {
      dedupedRooms[idx] = normalized;
    }
  });

  const newArray = dedupedRooms;
  let roomOrder = ["BEDROOM", "LIVING ROOM", "DORMITORY", "OTHER SPACES"];

  newArray.sort(
    (a, b) => roomOrder.indexOf(a.room_type) - roomOrder.indexOf(b.room_type)
  );

  const formatBeds = (beds = []) => {
    if (!beds.length) return "—";
    return beds
      .map((bed) => `${bed.quantity} ${formatBedDisplayName(bed.name)}`)
      .join(", ");
  };

  useEffect(() => {
    if (villaData && startDate && endDate) {
      let priceSum = 0;
      let flag = true;

      if (Object.prototype.toString.call(startDate) === "[object Date]" &&
        Object.prototype.toString.call(endDate) === "[object Date]") {

        for (
          let d = new Date(startDate);
          d < endDate;
          d.setDate(d.getDate() + 1)
        ) {
          let tempDate = d.toLocaleDateString('en-US', { timeZone: 'Asia/Kolkata' }).slice(0, 10);
          let dateStr = tempDate;
          let [month, day, year] = dateStr.split("/");
          let formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
          //console.log(formattedDate, "tempdate")
          console.log(tempDate,"date")
          if (villaData.availability_per_date[formattedDate] == 0) flag = false;
          priceSum += parseInt(villaData.price_per_date[formattedDate]);
        }
      }
      console.log(flag,"flag");
      if (!priceSum || priceSum === 0) flag = false;
      setAvailability(flag);
      if (flag) setTotalPrice(priceSum);
      else setTotalPrice(villaData.price_guest_pay);
      //console.log(priceSum, "Total wala");
    }
  }, [villaData, startDate, endDate]);

  useEffect(() => {
    let days = 0; // default value in case of invalid dates

    if (Object.prototype.toString.call(startDate) === "[object Date]" &&
      Object.prototype.toString.call(endDate) === "[object Date]") { // check if dates are valid
      let timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
      days = Math.ceil(timeDiff / (1000 * 3600 * 24));
      SetDateNull(false)
    }
    else {
      SetDateNull(true)
    }
    // //console.log(Object.prototype.toString.call(startDate),"startdate")
    // const days = (endDate.getTime() - startDate.getTime()) / 86400000;
    setPax(adults + children + infants);
    const billablePax = adults + children;
    if (includedPax >= billablePax) setExtraPrice(0);
    else {
      setExtraPrice(
        (billablePax - includedPax) *
        villaData.price_per_extra_person *
        days
      );
    }

    //console.log(extraPrice, "EXTRAA", days);
  }, [adults, children, infants, startDate, endDate]);

  useEffect(() => {
    if (!allowsPets && setPets && pets > 0) setPets(0);
  }, [allowsPets, pets, setPets]);

  //console.log(newArray, "data2");
  //console.log(villaData);

  const renderBedrooms = () => {
    // Show bedrooms with beds first; only include living/other if they have beds
    const displayRooms = newArray.filter((item) => {
      const type = String(item.room_type || "").toUpperCase();
      if (type === "BEDROOM" || type === "DORMITORY") return true;
      return (item.bed || []).length > 0;
    });

    if (!displayRooms.length) {
      return (
        <p className="text-sm text-center text-gray-500 py-2">
          Bedroom details not available
        </p>
      );
    }

    const mid = Math.ceil(displayRooms.length / 2);
    const firstColumn = displayRooms.slice(0, mid);
    const secondColumn = displayRooms.slice(mid);

    return (
      <>
        <div className="flex">
          <div className="w-1/2 mx-auto ">
            <ul className="space-y-1">
              {firstColumn.map((item, index) => (
                <li
                  style={{ textTransform: "capitalize" }}
                  key={`${item.room_type}-${item.room_name}-${item.id || index}`}
                >
                  <strong>•{item.room_name}:</strong> {formatBeds(item.bed)}
                </li>
              ))}
            </ul>
          </div>
          <div className="w-1/2 ">
            <ul className="space-y-1">
              {secondColumn.map((item, index) => (
                <li
                  style={{ textTransform: "capitalize" }}
                  key={`${item.room_type}-${item.room_name}-${item.id || index + mid}`}
                >
                  <strong>•{item.room_name}:</strong> {formatBeds(item.bed)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </>
    );
  };

  //BOOKING PAGE 4
  let thumbnailId = -1;
  if (villaData.main_media_id) thumbnailId = villaData.main_media_id;
  else if (villaData.media_order.length > 0)
    thumbnailId = villaData.media_order[0];
  else if (villaData.media.length > 0)
    thumbnailId = villaData.media[0].mediafiles_id;

  const thumbnail = villaData.media.filter((item) => {
    return thumbnailId === item.mediafiles_id;
  });


  const handleBookNow = () => {
    setStoredGuests({
      adults,
      children,
      infants,
      pets: allowsPets ? pets : 0,
    });
    const bookingData = {
      adults: adults,
      children: children,
      infants: infants,
      pets: allowsPets ? pets : 0,
      price: totalPrice + extraPrice,
      checkIn: startDate,
      checkOut: endDate,
      villaName: villaData.listing_name,
      villa_lat: villaData.geo_lat,
      host_id: villaData.host_id,
      villa_long: villaData.geo_long,
      villaAddress: villaData.area,
      villaCity: villaData.name,
      villaLandmark: villaData.building,
      cancellationPolicy: villaData.cancellation_policy,
      checkInTime: villaData.check_in_start_time,
      checkOutTime: villaData.check_out_time,
      damageDeposit: villaData.damage_deposit,
      thumbnail: thumbnail[0],
      prepayment: getGuestPrepaymentPercent(
        villaData.advance_percent,
        villaData.commmission
      ),
      taxFlag: villaData.is_tax_included,
      property_ptr_id: villaData.property_ptr_id,
      city_id:villaData.city_id
    };
    navigate("/payment", { state: bookingData });
  };




  // //console.log(newArray, "adsdsads");
  return (
    <>
      {isPopupOpen && (
        <BedroomPopup data={newArray} onClose={handleClosePopup} />
      )}
      <div>
        <div className="font-jt my-auto flex flex-col w-[97%] lg:w-[90vw] mx-auto">
          <div className="w-full">
            <div className="bg-[#EAEAEA] w-full mx-auto font-jt rounded-3xl shadow-md mt-5 justify-between flex flex-col md:flex-row">
              <div className="md:w-[40%] p-2 lg:p-6">
                <div className="text-[25px] lg:text-[30px]">Villa Type</div>

                <div className="grid grid-cols-3 gap-2 my-2 lg:my-5 space-x-2  ">
                  <div className="bg-white border border-[#E5E5E5] p-1 lg:p-2 rounded-2xl shadow-sm text-center">
                    <p className=" font-bold text-base lg:text-lg">
                      {villaData.size_of_property
                        ? villaData.size_of_property
                        : "N/A"}{" "}
                      Sq.ft{" "}
                    </p>
                    <p>Area</p>
                  </div>
                  <div className="bg-white border border-[#E5E5E5] p-1 lg:p-2 rounded-2xl shadow-sm text-center">
                    <p className=" font-bold text-base lg:text-lg">
                      {villaData.number_of_bedrooms
                        ? villaData.number_of_bedrooms
                        : "N/A"}
                    </p>
                    <p>BHK</p>
                  </div>
                  <div className="bg-white border border-[#E5E5E5] p-1 lg:p-2 rounded-2xl shadow-sm text-center">
                    <p className=" font-bold text-base lg:text-lg">{maxPax}</p>
                    <p>Max PAX</p>
                  </div>
                </div>
                <div>
                  <div className="bg-white border border-[#E5E5E5] p-2 rounded-2xl shadow-sm ">
                    <h2 className="text-xl lg:text-2xl mb-1  font-bold text-center">
                      {villaData.number_of_bedrooms} Bedroom
                    </h2>
                    {renderBedrooms()}
                    <div className="text-sm border-black text-purple-800 mt-1 text-center">
                      <button onClick={handleOpenPopup}>
                        Click to know more in detail
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="md:w-[35%] p-1 lg:p-6 flex flex-col justify-between">
                <div className="text-[24px] lg:text-[30px]">
                  Guests
                </div>

                <div className="bg-white rounded-2xl shadow-sm border border-[#E5E5E5] divide-y divide-[#EBEBEB] overflow-hidden my-2 lg:my-3">
                  <div className="flex flex-row items-center justify-between gap-3 px-4 py-3.5 lg:py-4">
                    <div className="min-w-0">
                      <div className="text-[16px] lg:text-[18px] font-semibold text-[#222]">
                        Adults
                      </div>
                      <div className="text-[13px] lg:text-[14px] text-[#717171] mt-0.5">
                        Ages 13 or above
                      </div>
                    </div>
                    <div className="flex items-center gap-3 shrink-0">
                      <button
                        type="button"
                        aria-label="Decrease adults"
                        onClick={() => {
                          if (adults > 0) setAdults(adults - 1);
                        }}
                        disabled={adults <= 0}
                        className={`w-8 h-8 rounded-full border border-[#B0B0B0] flex items-center justify-center text-[#222] text-xl leading-none ${
                          adults <= 0
                            ? "opacity-40 cursor-not-allowed"
                            : "hover:border-[#222]"
                        }`}
                      >
                        −
                      </button>
                      <span className="w-6 text-center text-[16px] font-medium tabular-nums">
                        {adults}
                      </span>
                      <button
                        type="button"
                        aria-label="Increase adults"
                        onClick={() => {
                          if (capacityPax < maxPax) setAdults(adults + 1);
                        }}
                        disabled={capacityPax >= maxPax}
                        className={`w-8 h-8 rounded-full border border-[#B0B0B0] flex items-center justify-center text-[#222] text-xl leading-none ${
                          capacityPax >= maxPax
                            ? "opacity-40 cursor-not-allowed"
                            : "hover:border-[#222]"
                        }`}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="flex flex-row items-center justify-between gap-3 px-4 py-3.5 lg:py-4">
                    <div className="min-w-0">
                      <div className="text-[16px] lg:text-[18px] font-semibold text-[#222]">
                        Children
                      </div>
                      <div className="text-[13px] lg:text-[14px] text-[#717171] mt-0.5">
                        Ages 6–12
                      </div>
                    </div>
                    <div className="flex items-center gap-3 shrink-0">
                      <button
                        type="button"
                        aria-label="Decrease children"
                        onClick={() => {
                          if (children > 0) setChildren(children - 1);
                        }}
                        disabled={children <= 0}
                        className={`w-8 h-8 rounded-full border border-[#B0B0B0] flex items-center justify-center text-[#222] text-xl leading-none ${
                          children <= 0
                            ? "opacity-40 cursor-not-allowed"
                            : "hover:border-[#222]"
                        }`}
                      >
                        −
                      </button>
                      <span className="w-6 text-center text-[16px] font-medium tabular-nums">
                        {children}
                      </span>
                      <button
                        type="button"
                        aria-label="Increase children"
                        onClick={() => {
                          if (capacityPax < maxPax) setChildren(children + 1);
                        }}
                        disabled={capacityPax >= maxPax}
                        className={`w-8 h-8 rounded-full border border-[#B0B0B0] flex items-center justify-center text-[#222] text-xl leading-none ${
                          capacityPax >= maxPax
                            ? "opacity-40 cursor-not-allowed"
                            : "hover:border-[#222]"
                        }`}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="flex flex-row items-center justify-between gap-3 px-4 py-3.5 lg:py-4">
                    <div className="min-w-0">
                      <div className="text-[16px] lg:text-[18px] font-semibold text-[#222]">
                        Little ones
                      </div>
                      <div className="text-[13px] lg:text-[14px] text-[#717171] mt-0.5">
                        Ages 0–5 years
                      </div>
                    </div>
                    <div className="flex items-center gap-3 shrink-0">
                      <button
                        type="button"
                        aria-label="Decrease little ones"
                        onClick={() => {
                          if (setInfants && infants > 0) setInfants(infants - 1);
                        }}
                        disabled={!setInfants || infants <= 0}
                        className={`w-8 h-8 rounded-full border border-[#B0B0B0] flex items-center justify-center text-[#222] text-xl leading-none ${
                          !setInfants || infants <= 0
                            ? "opacity-40 cursor-not-allowed"
                            : "hover:border-[#222]"
                        }`}
                      >
                        −
                      </button>
                      <span className="w-6 text-center text-[16px] font-medium tabular-nums">
                        {infants}
                      </span>
                      <button
                        type="button"
                        aria-label="Increase little ones"
                        onClick={() => {
                          if (setInfants && infants < 25) setInfants(infants + 1);
                        }}
                        disabled={!setInfants || infants >= 25}
                        className={`w-8 h-8 rounded-full border border-[#B0B0B0] flex items-center justify-center text-[#222] text-xl leading-none ${
                          !setInfants || infants >= 25
                            ? "opacity-40 cursor-not-allowed"
                            : "hover:border-[#222]"
                        }`}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {allowsPets && (
                  <div className="flex flex-row items-center justify-between gap-3 px-4 py-3.5 lg:py-4">
                    <div className="min-w-0">
                      <div className="text-[16px] lg:text-[18px] font-semibold text-[#222]">
                        Pets
                      </div>
                      <div className="text-[13px] lg:text-[14px] text-[#717171] mt-0.5 underline">
                        Bringing a service animal?
                      </div>
                    </div>
                    <div className="flex items-center gap-3 shrink-0">
                      <button
                        type="button"
                        aria-label="Decrease pets"
                        onClick={() => {
                          if (setPets && pets > 0) setPets(pets - 1);
                        }}
                        disabled={!setPets || pets <= 0}
                        className={`w-8 h-8 rounded-full border border-[#B0B0B0] flex items-center justify-center text-[#222] text-xl leading-none ${
                          !setPets || pets <= 0
                            ? "opacity-40 cursor-not-allowed"
                            : "hover:border-[#222]"
                        }`}
                      >
                        −
                      </button>
                      <span className="w-6 text-center text-[16px] font-medium tabular-nums">
                        {pets}
                      </span>
                      <button
                        type="button"
                        aria-label="Increase pets"
                        onClick={() => {
                          if (setPets && pets < 5) setPets(pets + 1);
                        }}
                        disabled={!setPets || pets >= 5}
                        className={`w-8 h-8 rounded-full border border-[#B0B0B0] flex items-center justify-center text-[#222] text-xl leading-none ${
                          !setPets || pets >= 5
                            ? "opacity-40 cursor-not-allowed"
                            : "hover:border-[#222]"
                        }`}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  )}
                </div>
                <div className="text-sm text-center text-gray-500 mb-2 ">
                  Price per extra Person: ₹{villaData.price_per_extra_person}
                  /-(For PAX above{" "}
                  {villaData.standard_occupany
                    ? villaData.standard_occupany
                    : villaData.number_of_adults +
                    Math.ceil(villaData.number_of_children / 2)}
                  )
                </div>
                {capacityPax > maxPax && (
                  <div className="text-red-600 lg:hidden shake-shake text-[15px] font-semibold flex justify-center text-center  mt-1 ">
                    Max capacity of villa exceeded! Please reduce the PAX.
                  </div>
                )}
                {DateNull && (
                  <div className="text-red-600 lg:hidden shake-shake text-[15px] font-semibold flex justify-center text-center  mt-1 ">
                    Please Select Dates to Adjust Prices
                  </div>
                )}
                <div className="items-center text-center">
                  <svg
                    className="mb-2 hidden lg:block"
                    width="500"
                    height="1"
                    viewBox="0 0 500 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line y1="0.5" x2="448.001" y2="0.5" stroke="#C6C6C6" />
                  </svg>
                  <div className="bg-white text-[20px] lg:text-[25px] border border-[#E5E5E5] shadow-sm font-semibold px-4 py-2 lg:py-3 rounded-2xl flex flex-row justify-between">
                    <div>Head Count</div>
                    <div>{pax}</div>
                  </div>
                </div>
              </div>

              <div className="md:w-[25%] rounded-b-3xl lg:rounded-bl-none lg:rounded-r-3xl    bg-[#2A2A2B] text-white flex flex-col justify-between p-1 lg:p-2">
                {availability && villaData.status === "OPEN/BOOKABLE" ? (
                  <>
                <div className=" text-[22px] lg:text-[30px] px-1 lg:p-6">
                  Price
                </div>
                <div className="h-full -mt-1 lg:mt-2 flex flex-col ">
                  <div className="flex justify-between space-x-1 px-2">
                    <div className=" hidden lg:flex flex-row">
                      <svg
                        width="65.449"
                        height="90"
                        viewBox="0 0 16 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.70096 0.700317C0.87253 0.700317 0.200958 1.37189 0.200958 2.20032V16.051C0.200958 16.5779 0.477406 17.0662 0.929214 17.3372L6.92921 20.9372C7.40423 21.2222 7.99767 21.2222 8.47269 20.9372L14.4727 17.3372C14.9245 17.0662 15.2009 16.5779 15.2009 16.051V2.20032C15.2009 1.37189 14.5294 0.700317 13.7009 0.700317H1.70096ZM1.70059 2.80039C2.03196 2.80039 2.30058 2.53176 2.30058 2.20039C2.30058 1.86902 2.03196 1.60039 1.70059 1.60039C1.36921 1.60039 1.10059 1.86902 1.10059 2.20039C1.10059 2.53176 1.36921 2.80039 1.70059 2.80039Z"
                          fill="white"
                        />
                      </svg>
                      <div className="absolute   mt-5 text-[#5C18CC]">
                        <p className="ml-3 text-2xl -mt-1 font-bold">12%</p>
                        <p className="text-center text-lg ml-1 -mt-1 font-bold">
                          off
                        </p>
                      </div>
                    </div>
                    <div className=" lg:hidden flex flex-row">
                      <svg
                        width="43.632"
                        height="60"
                        viewBox="0 0 16 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.70096 0.700317C0.87253 0.700317 0.200958 1.37189 0.200958 2.20032V16.051C0.200958 16.5779 0.477406 17.0662 0.929214 17.3372L6.92921 20.9372C7.40423 21.2222 7.99767 21.2222 8.47269 20.9372L14.4727 17.3372C14.9245 17.0662 15.2009 16.5779 15.2009 16.051V2.20032C15.2009 1.37189 14.5294 0.700317 13.7009 0.700317H1.70096ZM1.70059 2.80039C2.03196 2.80039 2.30058 2.53176 2.30058 2.20039C2.30058 1.86902 2.03196 1.60039 1.70059 1.60039C1.36921 1.60039 1.10059 1.86902 1.10059 2.20039C1.10059 2.53176 1.36921 2.80039 1.70059 2.80039Z"
                          fill="white"
                        />
                      </svg>
                      <div className="absolute   mt-5 text-[#5C18CC]">
                        <p className="ml-2 text-base lg:text-2xl -mt-3 font-bold">
                          12%
                        </p>
                        <p className="text-center text-base lg:text-lg ml-1 -mt-1 font-bold">
                          off
                        </p>
                      </div>
                    </div>
                    <div>
                        <div className="text-end  ">
                          {" "}
                          <div className="text-sm lg:text-2xl" >
                            <s>
                              ₹{Math.floor(1.12 * (totalPrice + extraPrice))}
                            </s>
                          </div>
                          <div className="text-3xl -mt-1 lg:-mt-0 lg:text-5xl">
                            ₹{totalPrice + extraPrice}
                          </div>
                        </div>
                    </div>
                  </div>
                  <div className="flex -mt-3 lg:-mt-0 text-[12px] lg:text-base text-end pr-2 space-y-1 flex-col">
                    <div>
                      +₹{calcTaxAmount(totalPrice + extraPrice)} TAX ({TAX_PERCENT}%)
                    </div>
                  </div>
                </div>

                  <div className="mt-3 lg:mt-0 lg:-mt-8 px-2 lg:px-3 pb-3 lg:pb-4 flex flex-col gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        if (startDate && endDate) handleBookNow();
                      }}
                      className={`w-full text-[22px] lg:text-[28px] font-bold text-center bg-green-600 hover:bg-green-700 border-green-600 border-2 text-white py-3.5 lg:py-4 rounded-2xl lg:-translate-y-3 ${
                        !DateNull ? "" : "opacity-[70%] hover:cursor-not-allowed"
                      }`}
                    >
                      BOOK NOW
                    </button>
                  <button
                    type="button"
                    onClick={() => setIsPolicyOpen(true)}
                    className="text-[12px] lg:text-[13px] underline text-center opacity-90 hover:opacity-100"
                  >
                    Explore Prepayment Policy
                  </button>
                </div>
                  </>
                ) : (
                  <div className="flex-1 flex items-center justify-center min-h-[180px] lg:min-h-[240px] px-3 py-6">
                    <div className="sold-out-cta sold-out-cta--tilt">
                      <span className="sold-out-cta__missed">You just missed it !!</span>
                      <span className="sold-out-cta__sold">Sold Out</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="w-full mt-2 px-1">
            {availability && capacityPax > maxPax && (
              <div className="text-red-600 text-[15px] lg:text-[16px] font-semibold flex justify-center text-center mt-2">
                Max capacity of villa exceeded! Please reduce the PAX.
              </div>
            )}
            {availability && DateNull && (
              <div className="text-red-600 text-[15px] lg:text-[16px] font-semibold flex justify-center text-center mt-2">
                Please Select Dates to Adjust Prices
              </div>
            )}
          </div>
        </div>
      </div>
      <PrepaymentPolicyModal
        isOpen={isPolicyOpen}
        onClose={() => setIsPolicyOpen(false)}
        villaData={villaData}
      />
    </>
  );
};

export default Layout;
